module.exports = __webpack_public_path__ + "img/ep7-6a.c86095b1.png";